import { Grid, GridProps } from '@mui/material'
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik'
import { AddressInfo } from '.'
import {
  AddButton,
  ContentWrapper,
  TitledSection
} from '../../../../../components'
import { OwnInfoDeleteButtonWrapperProps } from './own-info-delete-button-wrapper'
import { OwnInfoContact, OwnInfoContactProps } from './contact-info'
import { ContactInputType } from '../types'
import { isAddressInput } from '../utils'

type ContactInfoProps = Omit<
  OwnInfoContactProps,
  'arrayHelpers' | 'name' | 'onChange'
>

interface ContactInputComponentProps
  extends Pick<OwnInfoDeleteButtonWrapperProps, 'arrayHelpers'> {
  name: string
  input: ContactInputType
  contactInfoProps?: ContactInfoProps
}

export const ContactInputComponent = ({
  arrayHelpers,
  name,
  input,
  contactInfoProps
}: ContactInputComponentProps) => {
  const { setFieldValue } = useFormikContext()

  const executeOnChange = () => {
    setFieldValue(name + '.paivittaja_ok', 1)
  }

  const executeOnAddressChange = () => {
    setFieldValue(name + '.virheellinen', false)
    setFieldValue(name + '.paivittaja_ok', 1)
  }

  if (contactInfoProps) {
    return (
      <OwnInfoContact
        {...contactInfoProps}
        arrayHelpers={arrayHelpers}
        name={name}
        executeOnChangeFn={executeOnChange}
      />
    )
  } else if (isAddressInput(input))
    return (
      <AddressInfo
        arrayHelpers={arrayHelpers}
        name={name}
        address={input}
        executeOnChangeFn={executeOnAddressChange}
      />
    )
  return null
}

export interface OwnInfoContactWrapperProps
  extends Omit<
    ContactInputComponentProps,
    'arrayHelpers' | 'input' | 'contactInfoProps'
  > {
  keyPostfix: string
  newContactObject: ContactInputType
  gridProps: Pick<GridProps, 'md'>
  contactInfoProps?: Omit<
    ContactInfoProps,
    'arrayHelpers' | 'contactLabelTranslationId'
  >
  sectionTranslationId: string
}

export const OwnInfoContactWrapper = ({
  name,
  keyPostfix,
  sectionTranslationId,
  newContactObject,
  contactInfoProps,
  gridProps
}: OwnInfoContactWrapperProps) => {
  const translationIdSectionPrefix =
    'pages.ownInfoPage.baseDetails.' + sectionTranslationId
  return (
    <TitledSection translationid={translationIdSectionPrefix + '.sectionLabel'}>
      <FieldArray
        name={name}
        render={(arrayHelpers: FieldArrayRenderProps) => {
          const paths = name.split('.')
          let inputs = arrayHelpers.form.values
          paths.forEach((path) => {
            inputs = inputs ? inputs[path] : undefined
          })

          return (
            <Grid item {...gridProps} xs={12}>
              {inputs?.map((input: ContactInputType, index: number) => (
                <ContentWrapper
                  key={`user-${keyPostfix}-${index}`}
                  showContent={input !== null}
                >
                  <ContactInputComponent
                    arrayHelpers={arrayHelpers}
                    name={`${name}.${index}`}
                    {...{
                      input
                    }}
                    contactInfoProps={
                      contactInfoProps
                        ? {
                            ...contactInfoProps,
                            contactLabelTranslationId:
                              translationIdSectionPrefix
                          }
                        : undefined
                    }
                  />
                </ContentWrapper>
              ))}

              <AddButton
                translationId={translationIdSectionPrefix + '.add'}
                onClick={() => {
                  arrayHelpers.push(newContactObject)
                }}
              />
            </Grid>
          )
        }}
      />
    </TitledSection>
  )
}
